import React from 'react';
import { Download } from 'lucide-react';

import { cn } from '../../../../lib/utils';
import { CARD_SHADOW, InfoTip, SURFACE } from '../teams/premium';

// Shared shell for every Funnel widget (the /billing/envoy look, Nic
// 2026-10-25): white rounded card, an uppercase eyebrow, the bold title, the
// semantics caption behind an "i" (cohort vs activity vs right now, keeps the
// numbers defensible), and a per-card CSV export of exactly this widget's
// rows.
const ChartCard = ({ title, eyebrow, caption, onExport, className, children }) => (
  // h-full + flex column so side-by-side cards in a grid row match heights.
  <div className={cn('flex h-full flex-col rounded-2xl p-5', SURFACE, CARD_SHADOW, className)}>
    <div className="mb-4 flex items-start justify-between gap-2">
      <div className="min-w-0">
        {eyebrow ? (
          <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">{eyebrow}</div>
        ) : null}
        <h3 className="m-0 mt-0.5 flex items-center gap-1.5 text-base font-semibold text-slate-900 dark:text-white">
          {title}
          {caption ? <InfoTip label={caption} align="left" /> : null}
        </h3>
      </div>
      {onExport ? (
        <button
          type="button"
          title="Export this card's data (CSV)"
          aria-label="Export this card's data (CSV)"
          onClick={onExport}
          className="shrink-0 rounded-lg p-1.5 text-slate-400 transition-[color,background-color] hover:bg-slate-100 hover:text-slate-700 dark:hover:bg-white/10 dark:hover:text-white"
        >
          <Download className="h-4 w-4" />
        </button>
      ) : null}
    </div>
    <div className="min-h-0 flex-1">{children}</div>
  </div>
);

export default ChartCard;
